import { Grid, MenuItem, TextField } from "@mui/material";
import { useLanguage } from "contexts/language.context";
import { ncrRepetitionError } from "../ncrTextValidation";

export default function NcrReportFields({ value, onChange }) {
  const { label } = useLanguage();
  const error = ncrRepetitionError(value?.repetitionTime);
  return (
    <>
      <Grid item xs={12} md={6}>
        <TextField
          select required fullWidth id="ncr-status" name="statusId" label={label("status-singular") || "Status"}
          value={value?.statusId ?? ""}
          onChange={(event) => onChange((current) => ({ ...current, statusId: event.target.value }))}
        >
          <MenuItem value={1}>{label("status-pending") || "Pending"}</MenuItem>
          <MenuItem value={2}>{label("ncr-status-done") || "Done"}</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField
          fullWidth type="number" id="ncr-repetition-time" name="repetitionTime"
          label={label("repetition-time-singular") || "Repetition time"}
          value={value?.repetitionTime ?? ""} inputProps={{ min: 0, max: 2147483647, step: 1 }}
          error={Boolean(error)} helperText={error}
          onChange={(event) => onChange((current) => ({ ...current, repetitionTime: event.target.value }))}
        />
      </Grid>
    </>
  );
}
